import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Text,
  Image,
  Flex,
  IconButton,
  HStack,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import axios from "axios";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import TrophyIcon from "../../assets/trophy.png";
import Trophy from "../../assets/trophy-1.png";
import Coin from "../../assets/coin.png";
import WinnerLeftImg from "../../assets/_ÎÓÈ_3 (1).png";




// Pulsing animation for LIVE badge
const pulse = keyframes`
  0% {
    box-shadow: 0 0 15px rgba(229, 62, 62, 0.9), 0 0 5px rgba(255,255,255,0.5);
  }
  50% {
    box-shadow: 0 0 25px rgba(229, 62, 62, 1), 0 0 10px rgba(255,255,255,0.8), 0 0 40px rgba(229, 62, 62, 0.6);
  }
  100% {
    box-shadow: 0 0 15px rgba(229, 62, 62, 0.9), 0 0 5px rgba(255,255,255,0.5);
  }
`;

const dotPulse = keyframes`
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.3);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

export default function Tournaments() {
  const swiperRefs = useRef([]);
  const [ludoTourneys, setLudoTourneys] = useState([]);
  const [rummyTourneys, setRummyTourneys] = useState([]);
  const [activeLudoTourneys, setActiveLudoTourneys] = useState([]);
  const [activeRummyTourneys, setActiveRummyTourneys] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentTime, setCurrentTime] = useState(new Date());

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedTourney, setSelectedTourney] = useState(null);

  // Refresh every minute so cards auto-disappear when their date+time passes
  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);




  useEffect(() => {
    const fetchTourneys = async () => {
      setIsLoading(true);

      try {
        // Date formatting helper (clean)
        const formatDate = (date) => {
          return new Date(date).toISOString().split("T")[0];
        };

        const today = new Date();
        const oneMonthAgo = new Date();
        oneMonthAgo.setMonth(today.getMonth() - 1);

        const from_date = formatDate(oneMonthAgo);
        const end_date = formatDate(today);

        // ✅ API URLs
        const ludoUrl = `https://api.winnsta.com/api/v1/admin/tournament-winners?game_category=4&page=1&search_key=&from_date=${from_date}&end_date=${end_date}`;
        const rummyUrl = `https://api.winnsta.com/api/v1/admin/tournament-winners?game_category=3&page=1&search_key=&from_date=${from_date}&end_date=${end_date}`;

        // ✅ Active Tournaments APIs
        const activeLudoUrl = `https://api.winnsta.com/api/v1/admin/active-tournaments?game_category=4&page=1&search_key=`;
        const activeRummyUrl = `https://api.winnsta.com/api/v1/admin/active-tournaments?game_category=3&page=1&search_key=`;

        // ✅ Parallel API calls (FAST 🚀)
        const [ludoRes, rummyRes, activeLudoRes, activeRummyRes] = await Promise.all([
          axios.get(ludoUrl),
          axios.get(rummyUrl),
          axios.get(activeLudoUrl),
          axios.get(activeRummyUrl),
        ]);

        // Safe data handling & filter out test tournaments
        const filterTestTourneys = (tourneys) => {
          if (!tourneys) return [];
          return tourneys.filter(t => !(t.tournament_name || "").toLowerCase().includes("test"));
        };

        setLudoTourneys(filterTestTourneys(ludoRes?.data?.data));
        setRummyTourneys(filterTestTourneys(rummyRes?.data?.data));
        setActiveLudoTourneys(filterTestTourneys(activeLudoRes?.data?.data));
        setActiveRummyTourneys(filterTestTourneys(activeRummyRes?.data?.data));

      } catch (err) {
        console.error("Error fetching tourneys:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTourneys();
  }, []);
  const getTourneys = (gameTitle) => {
    let data = [];
    if (gameTitle === "Ludo") data = ludoTourneys;
    else if (gameTitle === "Rummy") data = rummyTourneys;
    
    // Filter out tournaments that have no winners (cancelled or not played)
    // This prevents "Results pending" cards from showing for cancelled tournaments
    return data.filter(t => t.winners && t.winners.length > 0);
  };

  const openWinnersModal = (tourney) => {
    setSelectedTourney(tourney);
    onOpen();
  };

  return (
    <Box
      position="relative"
      overflow="hidden"
      px={{ base: 4, md: 12 }}
      py={14}
      minH="100vh"
      color="white"
      bg="radial-gradient(circle at top left, #2a0a3d 0%, #12071f 40%, #06020d 80%)"
    >
      {/* TROPHY BACKGROUND */}
      <Box
        position="absolute"
        top="60%"
        right={{ base: "-80px", md: "-250px" }}
        transform="translateY(-50%)"
        w={{ base: "420px", md: "80%" }}
        h={{ base: "420px", md: "80%" }}
        bgImage={`url(${Trophy})`}
        bgRepeat="no-repeat"
        bgSize="contain"
        bgPosition="center"
        opacity={0.9}   // much stronger
        filter="brightness(2) contrast(1.2)"  // make it visible
        pointerEvents="none"
        zIndex={0}
      />

      {/* MAIN CONTENT */}
      <Box position="relative" zIndex={2}>

        {/* HEADER */}
        <Flex direction={{ base: "column", md: "row" }} mb={14}>
          <Box>
            <Text
              fontSize={{ base: "3xl", md: "80px" }}
              fontWeight="extrabold"
              bgGradient="linear(to-r, #FFFFFF, #BDA8FB)"
              bgClip="text"
              lineHeight="1"
            >
              TOURNAMENTS
            </Text>
            <Text color="#A78BFA" my={{ base: 8 }} pr={{ md: 40 }} fontSize={{ base: "22px", md: "25px" }} lineHeight="1.3">
              Our live tournaments are now running for Ludo and Rummy. Jump in, compete with real players, show off your skills, and climb the leaderboards. Big wins, real-time action, and non-stop fun await!
              <br />
              <b>Join the tournament now and play to win!</b>
            </Text>
          </Box>

          <Image
            src={TrophyIcon}
            alt="Trophy"
            w={{ base: "40%", md: "30%" }}

          />
        </Flex>

        {/* Dynamic Tournament Sections */}
        {[
          { title: "LUDO", data: activeLudoTourneys },
          { title: "RUMMY", data: activeRummyTourneys }
        ].some(section => section.data.some(t => !t.winners || t.winners.length === 0)) && (
            <Box
              position="relative"
              borderRadius="40px"
              p={{ base: 6, md: 6 }}
              bg="rgba(30, 10, 60, 0.55)"
              border="1px solid rgba(255,255,255,0.08)"
              boxShadow="
              inset 0 0 80px rgba(168, 85, 247, 0.1),
              0 0 120px rgba(139, 92, 246, 0.25)
            "
            >
              {/* inner glow light */}
              <Box
                position="absolute"
                inset={0}
                borderRadius="40px"
                bg="linear-gradient(135deg, rgba(168,85,247,0.15), transparent 40%)"
                pointerEvents="none"
              />

              {[
                { title: "LUDO", data: activeLudoTourneys },
                { title: "RUMMY", data: activeRummyTourneys }
              ].map((section, idx) => {
                const visibleCards = section.data.filter(t => !t.winners || t.winners.length === 0);
                if (visibleCards.length === 0) return null;

                return (
                  <Box key={idx} mb={idx === 1 ? 0 : 12} position="relative">
                    <Flex justify="space-between" align="center" mb={6}>
                      <Text fontSize={{ base: "34px", md: "60px" }} fontWeight="bold">
                        {section.title}
                      </Text>
                    </Flex>

                    <Swiper
                      modules={[Pagination, Autoplay]}
                      onSwiper={(swiper) => (swiperRefs.current[idx] = swiper)}
                      spaceBetween={20}
                      slidesPerView={1.2}
                      breakpoints={{
                        480: { slidesPerView: 1.5 },
                        768: { slidesPerView: 2.2 },
                        1024: { slidesPerView: 3 },
                      }}
                      autoplay={visibleCards.length > 3 ? { delay: 3000, disableOnInteraction: false } : false}
                      pagination={{ clickable: true }}
                      style={{ paddingBottom: "40px", paddingTop: "20px" }}
                    >
                      {visibleCards.map((tourney, i) => {
                        const scheduledDate = new Date(tourney.scheduled_date || tourney.createdAt);
                        const now = currentTime;
                        const rawPrize = tourney.prize_structure?.[0]?.price || tourney.tournament_json_data?.total_winning_prize || "TBD";
                        const prizeText = rawPrize.toString().replace(/_/g, " ");
                        const playerSize = tourney.tournament_json_data?.player_size || tourney.tournament_json_data?.players || tourney.max_players || "N/A";
                        const entryFee = tourney.tournament_json_data?.entry_fee || tourney.entry_fee || "Free";
                        const gameTime = tourney.tournament_json_data?.game_time || "TBD";
                        const isNextTournament = i === 0;
                        const diffInMs = scheduledDate - now;
                        const showPrize = diffInMs < (2 * 24 * 60 * 60 * 1000); // within 2 days
                        const isLive = !tourney.winners || tourney.winners.length === 0;

                        const bg = isNextTournament
                          ? "linear-gradient(135deg, #D442FF 0%, #6000D3 100%)"
                          : "linear-gradient(135deg, #22093D 0%, #6210A8 100%)";
                        const borderStyle = isNextTournament
                          ? "1px solid rgba(255,255,255,0.4)"
                          : "1px solid rgba(255,255,255,0.15)";

                        return (
                          <SwiperSlide key={i} style={{ height: "auto" }}>
                            <Box
                              px={{ base: 4, md: 6 }}
                              py={{ base: 4, md: 5 }}
                              minH={{ base: "180px", md: "200px" }}
                              h="100%"
                              borderRadius="30px"
                              display="flex"
                              flexDirection="column"
                              justifyContent="space-between"
                              alignItems="center"
                              textAlign="center"
                              bg={bg}
                              border={borderStyle}
                              transition="all 0.3s ease"
                              _hover={{
                                transform: "translateY(-6px)",
                                boxShadow: isNextTournament ? "0 10px 30px rgba(168, 85, 247, 0.4)" : "none"
                              }}
                              position="relative"
                              overflow="visible"
                            >
                              {isLive && (
                                <Flex 
                                  position="absolute" 
                                  top={{ base: "8px", md: "10px" }} 
                                  left={{ base: "16px", md: "20px" }} 
                                  color="white" 
                                  fontSize={{ base: "9px", md: "11px" }} 
                                  fontWeight="bold" 
                                  zIndex={10} 
                                  align="center" 
                                  gap={1}
                                >
                                  <Box 
                                    w="5px" 
                                    h="5px" 
                                    bg="#FF4444" 
                                    borderRadius="full"
                                    animation={`${dotPulse} 1.5s ease-in-out infinite`}
                                  />
                                  LIVE
                                </Flex>
                              )}
                              <Box w="100%">
                                <Text fontWeight="900" fontSize={{ base: "25px", md: "30px" }} lineHeight="1.1" color="white" mb={1} style={{ textShadow: "0 2px 8px rgba(0,0,0,0.2)" }}>
                                  {tourney.tournament_name}
                                </Text>
                                <Flex justify="center" align="center" gap={{ base: 2, md: 4 }} fontSize={{ base: "9px", md: "11px" }} color="rgba(255,255,255,0.85)" fontWeight="medium" mb={2}>
                                  <Text>Player size: {playerSize}</Text>
                                  <Text>Entry fee: {entryFee}</Text>
                                </Flex>
                              </Box>

                              <Box my={1} flex={1} display="flex" alignItems="center" justifyContent="center">
                                {showPrize ? (
                                  !prizeText.toLowerCase().includes("voucher") ? (
                                    <Flex align="center" justify="center" gap={{ base: 2, md: 3 }}>
                                      <Image src={Coin} alt="coin" boxSize={{ base: "30px", md: "50px" }} filter="drop-shadow(0 4px 10px rgba(0,0,0,0.3))" />
                                      <Text fontSize={{ base: "32px", md: "56px" }} fontWeight="900" color="white" lineHeight="1" style={{ textShadow: "0 4px 15px rgba(0,0,0,0.3)" }}>
                                        {prizeText.split(" ")[0]}
                                      </Text>
                                    </Flex>
                                  ) : (
                                    <Text fontSize={{ base: "20px", md: "35px" }} fontWeight="900" color="white" style={{ textShadow: "0 3px 10px rgba(0,0,0,0.4)" }}>
                                      {prizeText}
                                    </Text>
                                  )
                                ) : (
                                  <Text fontSize={{ base: "11px", md: "14px" }} fontWeight="bold" color="whiteAlpha.700" letterSpacing="0.08em">
                                    UPCOMING TOURNAMENT
                                  </Text>
                                )}
                              </Box>

                              <Flex w="100%" justify="space-between" align="center" fontSize={{ base: "9px", md: "12px" }} color="rgba(255,255,255,0.95)" fontWeight="bold" pt={1}>
                                <Text>Date: {new Date(tourney.scheduled_date || tourney.createdAt).toLocaleDateString('en-GB').replace(/\//g, '-')}</Text>
                                <Text>Timing: {gameTime}</Text>
                              </Flex>
                            </Box>
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                  </Box>
                );
              })}
            </Box>
          )}
        {/* WINNERS SECTION */}
        {(!isLoading && ludoTourneys.length === 0 && rummyTourneys.length === 0) ? null : (
          <Box mt={20} position="relative">

            {/* Trophy left */}
            <Box
              position="absolute"
              left={{ base: "-80px", md: "-180px" }}
              top="50%"
              transform="translateY(-50%)"
              w={{ base: "180px", md: "350px" }}
              opacity={0.85}
              pointerEvents="none"
              zIndex={0}
            >
              <Image src={WinnerLeftImg} alt="winner decoration left" />
            </Box>

            {/* Glass cards container */}
            <Flex
              direction={{ base: "column", xl: "row" }}
              gap={{ base: 8, md: 10 }}
              maxW="1300px"
              mx="auto"
              position="relative"
              zIndex={1}
              justify="center"
            >
              {["Ludo", "Rummy", "Cricket"].map((gameTitle, idx) => {
                if (!isLoading && getTourneys(gameTitle).length === 0) return null;
                return (
                  <Box
                    key={idx}
                    flex={1}
                    position="relative"
                    borderRadius="32px"
                    p={{ base: 6, md: 8 }}
                    bg="rgba(30, 10, 60, 0.75)"
                    border="1px solid rgba(255,255,255,0.1)"
                    boxShadow="0 0 80px rgba(139, 92, 246, 0.3), inset 0 0 40px rgba(168,85,247,0.08)"
                    backdropFilter="blur(16px)"
                  >
                    <Box textAlign="center" mb={{ base: 4, md: 6 }} position="relative">
                      <Box position="relative" display="inline-block" mt={{ base: 10, md: 16 }}>
                        <Text
                          fontFamily={"'Kapakana', cursive"}
                          fontSize={{ base: "70px", md: "100px" }}
                          bgGradient="linear(to-r, #F8A800, #F6FF00)"
                          bgClip="text"
                          position="absolute"
                          top={{ base: "-50px", md: "-80px" }}
                          left={{ base: "-10px", md: "-20px" }}
                          lineHeight="1.4"
                          pb={6}
                          px={4}
                          zIndex={2}
                        >
                          {gameTitle}
                        </Text>
                        <Text
                          fontSize={{ base: "36px", md: "50px" }}
                          fontWeight="extrabold"
                          bgGradient="linear(to-r, #FFFFFF, #BDA8FB)"
                          bgClip="text"
                          letterSpacing="0.05em"
                          lineHeight="1"
                          position="relative"
                          zIndex={1}
                        >
                          WINNERS
                        </Text>
                      </Box>
                    </Box>

                    {/* TOURNAMENT CARDS */}
                    <Flex direction="column" gap={4} pt={2} pb={4} maxH="550px" overflowY="auto" pr={2} css={{ '&::-webkit-scrollbar': { width: '6px' }, '&::-webkit-scrollbar-thumb': { background: '#8B5CF6', borderRadius: '10px' } }}>
                      {getTourneys(gameTitle).map((t, idx) => {
                        const prizeText = t.prize_structure?.[0]?.price || "TBD";
                        const isWinnerAvailable = t.winners && t.winners.length > 0;
                        return (
                          <Box
                            key={t.tournament_id || idx}
                            p={4}
                            borderRadius="16px"
                            bg="rgba(255,255,255,0.05)"
                            border="1px solid rgba(255,255,255,0.1)"
                            cursor="pointer"
                            _hover={{ bg: "rgba(167,139,250,0.15)", transform: "translateY(-2px)", transition: "0.2s" }}
                            onClick={() => openWinnersModal(t)}
                            transition="0.2s"
                            position="relative"
                          >
                            <Flex justify="space-between" align="center" mb={2}>
                              <Text fontWeight="extrabold" fontSize={{ base: "16px", md: "20px" }} color="white">
                                {t.tournament_name || "Tournament"}
                              </Text>
                              <Text fontWeight="bold" fontSize={{ base: "14px", md: "16px" }} color="#F6E05E">
                                Prize: {prizeText}
                              </Text>
                            </Flex>

                            <Flex justify="space-between" align="center" mt={2} opacity={0.8}>
                              <Text fontSize={{ base: "10px", md: "12px" }} color="gray.300">
                                {new Date(t.scheduled_date || t.createdAt).toLocaleDateString()} • {t.tournament_json_data?.game_time || "LIVE"}
                              </Text>
                              <Text fontSize={{ base: "10px", md: "12px" }} color="#BDA8FB">
                                {gameTitle === "Ludo" ? "Classic Ludo" : "Rummy"}
                              </Text>
                            </Flex>

                            <Text mt={3} fontSize="11px" textAlign="center" color="#A78BFA" fontWeight="bold">
                              {isWinnerAvailable ? "Click to view results 🏆" : "Results pending ⏳"}
                            </Text>
                          </Box>
                        );
                      })}
                      {(isLoading && getTourneys(gameTitle).length === 0) && (
                        <Text textAlign="center" color="gray.400" mt={6} pb={10}>Loading tournaments...</Text>
                      )}
                    </Flex>
                  </Box>
                );
              })}
            </Flex>
          </Box>
        )}

        <Box
          position="absolute"
          top="78%"
          right="-200px"
          w="700px"
          h="600px"
          bg="radial-gradient(circle, #8B5CF6 0%, rgba(0,0,0,0) 70%)"
          filter="blur(120px)"
          zIndex={-1}
          pointerEvents="none"
        />
      </Box>

      {/* WINNERS MODAL */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
        <ModalOverlay backdropFilter="blur(5px)" bg="blackAlpha.800" />
        <ModalContent bg="linear-gradient(135deg, #2a0a3d 0%, #12071f 100%)" color="white" border="1px solid rgba(139, 92, 246, 0.3)" borderRadius="24px" overflow="hidden">
          <ModalHeader textAlign="center" fontSize="24px" fontWeight="extrabold" color="#F6E05E">
            {selectedTourney?.tournament_name || "Tournament"} Winners
          </ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody pb={6} maxH="60vh" overflowY="auto" css={{ '&::-webkit-scrollbar': { width: '4px' }, '&::-webkit-scrollbar-thumb': { background: '#A78BFA' } }}>
            {selectedTourney?.winners && selectedTourney.winners.length > 0 ? (
              <Box>
                <Flex justify="space-between" px={4} mb={3}>
                  {["RANK", "PROFILE", "NAME", "PRIZE"].map((h) => (
                    <Text key={h} fontWeight="bold" fontSize="12px" color="#F6AD55" flex={h === "RANK" || h === "PROFILE" ? 0.5 : 1} textAlign="center">
                      {h}
                    </Text>
                  ))}
                </Flex>
                <Box h="1px" bg="rgba(255,255,255,0.1)" mb={3} />
                {selectedTourney.winners.map((w, idx) => (
                  <Flex key={idx} align="center" justify="space-between" px={4} py={3} mb={2} bg={idx % 2 === 0 ? "rgba(255,255,255,0.05)" : "transparent"} borderRadius="10px">
                    <Text flex={0.5} textAlign="center" fontSize="18px">
                      {w.rank === 1 ? "🥇" : w.rank === 2 ? "🥈" : w.rank === 3 ? "🥉" : w.rank}
                    </Text>
                    <Flex flex={0.5} justify="center">
                      <Image src={w.profile_image || "https://img.icons8.com/m_rounded/512/FFFFFF/user.png"} boxSize="28px" borderRadius="full" objectFit="cover" bg="whiteAlpha.200" p={w.profile_image ? 0 : 1} />
                    </Flex>
                    <Text flex={1} textAlign="center" fontWeight="bold" fontSize="14px" color="white" isTruncated>
                      {w.username}
                    </Text>
                    <Text flex={1} textAlign="center" fontWeight="bold" fontSize="13px" color="#A78BFA" isTruncated>
                      {w.prize}
                    </Text>
                  </Flex>
                ))}
              </Box>
            ) : (
              <Text textAlign="center" color="gray.400" py={10}>No winners declared yet for this tournament.</Text>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
}
